import { message } from "antd";
// import "../assets/css/antd.css";

message.config({
  top: 50,
});

export default message;
